import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";

export const useWorkspaceFilesStyles = makeStyles({
  contextFilesLayout: {
    flex: 1,
    overflowY: "auto",
    padding: designTokens.spacing[8],
  },
  contextFilesContent: {
    maxWidth: "1120px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
  },
  sharedLayerBanner: {
    display: "flex",
    gap: designTokens.spacing[2],
    padding: designTokens.spacing[3],
    background: projectIqTokens.tealSoft,
    borderRadius: designTokens.borderRadius.md,
    color: designTokens.accent[700],
  },
  sharedLayerBannerIcon: {
    color: designTokens.accent[700],
    fontSize: designTokens.fontSize.lg,
    flexShrink: 0,
  },
  sharedLayerBannerText: {
    fontSize: designTokens.fontSize.xs,
  },
});
